import { Chip } from 'react-md'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { getIsFetchingTags, getTag, getTags } from 'redux/reducers'
import * as actions from 'redux/actions'

import './index.css'

const renderChip = ({ input, meta, onRemove, ...rest }) => (
  <Chip onClick={onRemove} {...rest} />
)

class TagList extends Component {
  constructor (props) {
    super(props)

    this.getTagName = this.getTagName.bind(this)
    this.onDelete = this.onDelete.bind(this)
  }

  componentWillMount () {
    const { loadTags, isFetchingTags, tags } = this.props

    if (!tags.length && !isFetchingTags) {
      loadTags()
    }
  }

  getTagName (tagIndex) {
    const { fields, getTag } = this.props

    return getTag(fields.get(tagIndex)).name || ''
  }

  onDelete (tagIndex) {
    const { fields, disabled } = this.props

    if (!disabled) {
      fields.remove(tagIndex)
    }
  }

  render () {
    const { fields, disabled } = this.props

    const containTags = fields && fields.length

    if (!containTags) {
      return (
        <div className='tag-list md-cell md-cell--12'>
          <div className='no-tags'>
            No tags.
          </div>
        </div>
      )
    }

    return (
      <div className='tag-list md-cell md-cell--12'>
        { fields.map((member, index) => (
          <Field
            key={index}
            name={`${member}.name`}
            component={renderChip}
            removable={!disabled}
            onRemove={() => this.onDelete(index)}
            label={this.getTagName(index)}
          />
        )) }
      </div>
    )
  }
}

TagList.propTypes = {
  getTag: PropTypes.func.isRequired,
  tags: PropTypes.array.isRequired,
  isFetchingTags: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  getTag: (id) => getTag(state, id),
  isFetchingTags: getIsFetchingTags(state),
  tags: getTags(state)
})

export default connect(mapStateToProps, actions)(TagList)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/BasicInfoView/TagList/index.js